import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { exceptionHandler } from '../../base/decorators';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import qs from 'qs';
import { COPY_INFO, DOWNLOAD_INFO, PREVIEW_INFO, PREVIEW_QUERY, } from './cgi-path';
var FileMetaRepo = /** @class */ (function () {
    function FileMetaRepo() {
    }
    FileMetaRepo.prototype.fetchPreviewInfo = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var fileId, _a, addBrowseRecord, previewAttribute, srcType, dstType, page, sheet, showComment, quality, scale, queryStringParams, queryString, requestBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fileId = req.fileId, _a = req.addBrowseRecord, addBrowseRecord = _a === void 0 ? true : _a, previewAttribute = req.previewAttribute;
                        srcType = previewAttribute.srcType, dstType = previewAttribute.dstType, page = previewAttribute.page, sheet = previewAttribute.sheet, showComment = previewAttribute.showComment, quality = previewAttribute.quality, scale = previewAttribute.scale;
                        queryStringParams = { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) };
                        queryString = qs.stringify(queryStringParams);
                        requestBody = {
                            file_id: fileId,
                            add_browse_record: addBrowseRecord,
                            preview_attr: {
                                page: page,
                                sheet: sheet,
                                quality: quality,
                                scale: scale,
                                src_type: srcType,
                                ddst_type: dstType,
                                show_comment: showComment,
                            },
                        };
                        return [4 /*yield*/, networkRequest.post("".concat(PREVIEW_INFO, "?").concat(queryString), requestBody)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * 查询文件预览信息
     */
    FileMetaRepo.prototype.fetchPreviewQuery = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var fileId, shouldRetry, queryStringParams, queryString, postJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileId = req.fileId, shouldRetry = req.shouldRetry;
                        queryStringParams = { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) };
                        queryString = qs.stringify(queryStringParams);
                        postJson = {
                            file_id: fileId,
                        };
                        // 如果配置了 shouldRetry 设置为 true; false 要带这个字段
                        if (shouldRetry)
                            postJson.should_retry = true;
                        return [4 /*yield*/, networkRequest.post("".concat(PREVIEW_QUERY, "?").concat(queryString), postJson)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FileMetaRepo.prototype.fetchDownloadInfo = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryStringParams, queryString, requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryStringParams = { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) };
                        queryString = qs.stringify(queryStringParams);
                        requestBody = { file_id: docId };
                        return [4 /*yield*/, networkRequest.post("".concat(DOWNLOAD_INFO, "?").concat(queryString), requestBody)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FileMetaRepo.prototype.fetchCopyInfo = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryStringParams, queryString, requestBody;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryStringParams = { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) };
                        queryString = qs.stringify(queryStringParams);
                        requestBody = { file_id: docId };
                        return [4 /*yield*/, networkRequest.post("".concat(COPY_INFO, "?").concat(queryString), requestBody)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FileMetaRepo.prototype, "fetchPreviewInfo", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], FileMetaRepo.prototype, "fetchDownloadInfo", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], FileMetaRepo.prototype, "fetchCopyInfo", null);
    return FileMetaRepo;
}());
export { FileMetaRepo };
